import HeroSection from "./HeroSection";
import AboutPreview from "./AboutPreview";
import StatsSection from "./StatsSection";
import ServicesPreview from "./ServicesPreview";
import GallerySection from "./GallerySection";
import WhyChooseUsPreview from "./WhyChooseUsPreview";
import ValuesPreview from "./ValuesPreview";
import ApproachPreview from "./ApproachPreview";
import ContactCTA from "./ContactCTA";

export default function Home() {
  return (
    <>
      <HeroSection />
      <AboutPreview />
      <StatsSection />
      <ServicesPreview />
      <GallerySection />
      <WhyChooseUsPreview />
      <ValuesPreview />
      <ApproachPreview />
      <ContactCTA />
    </>
  );
}
